import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Translation } from "react-i18next";
import i18n from "i18n";

class Packages extends Component {
    render() {
        return (
            <Translation>
                {t => (
                    <div className={"global-view"}>
                        {"Packages"}
                    </div>
                )}
            </Translation>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Packages)
